import { FC } from 'react'

import ConfirmModal from '../ConfirmModal'

export type UnsavedChangesModalProps = {
  isOpen: boolean
  title?: string
  description?: string | null
  leftButtonLabel?: string
  rightButtonLabel?: string
  onDiscard(): void
  onKeepEditing?(): void
  modal?: boolean
}

const UnsavedChangesModal: FC<UnsavedChangesModalProps> = ({
  isOpen,
  onDiscard,
  onKeepEditing,
  title = 'Unsaved changes',
  description = 'Do you want to keep editing or leave?',
  leftButtonLabel = 'Discard changes',
  rightButtonLabel = 'Back to edit',
  modal = true,
}) => (
  <ConfirmModal
    open={isOpen}
    onClose={onDiscard}
    title={title}
    modal={modal}
    closeOnOutsideClick={false}
    className="max-w-[450px]"
    leftButton={{
      title: leftButtonLabel,
      variant: 'secondary',
      onClick: onDiscard,
    }}
    rightButton={{
      title: rightButtonLabel,
      variant: 'primary',
      onClick: onKeepEditing,
    }}
  >
    {description && description}
  </ConfirmModal>
)

export default UnsavedChangesModal
